import React, { Component } from "react";
import ReadAxios from "../../../components/axiosComponent/read";
import AgGridTable from "../../../components/common/agGridTable";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { FEATURES } from "../../../utils/constant";

class VendorGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
    })
      .then((dataArray) => {
        console.log(dataArray);
        this.setState({
          rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_VENDOR_GROUP.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-vendor-group", {
      ...rowData,
      title: localStorage.getItem != 1158 ? "edit_vendor_title" : "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/vendor-group");
    this.props.history.go();
  };

  render() {
    const { t } = this.props;
    const customerNo = localStorage.getItem('customerNumber')

    const Columns = [
      {
        headerName: t("table_header.group_name") || "Group Name",
        field: "vendorGroupName",
      },
      {
        headerName: t(customerNo != 1158 ? "table_header.total_vendor" : "table_header.total_partner") || "Total Vendor",
        field: `vendors.length`,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdByUser.name",
      },
      {
        headerName: t("table_header.group_code") || "Group Code",
        field: "vendorGroupCode",
      },
      {
        headerName: t("table_header.created_on") || "Last Created Date",
        field: "createdOn",
      },
      {
        headerName: t("table_header.modified_by") || "Updated By",
        field: "updatedByUser.name",
      },
      {
        headerName: t("table_header.modified_on") || "Updated Date",
        field: "updatedOn",
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        pinned: "right",
        suppressToolPanel: true,
        hide: !this.props.permissions.TA_VENDOR_GROUP.UPDATE && !this.props.permissions.TA_VENDOR_GROUP.DELETE,
      },
    ];
    const { rowData } = this.state;
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t(customerNo != 1158 ? "vendor_title" : "title") || "Vendor Group"}
          titleBarLink={"/add-vendor-group"}
          completeURL={`${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`}
          keyIndex={"vendorGroupId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_VENDOR_GROUP.UPDATE}
          hideRowDelete={!this.props.permissions.TA_VENDOR_GROUP.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("vendor_group")(VendorGroup));
